// eslint-disable-next-line import/prefer-default-export
export const FILTER_DEBOUNCE_TIME = 300;
export const DEFAULT_ITEMS_PER_PAGE = 10;
export const MIN_SEARCH_PHRASE_LENGTH = 3;
